export default "__VITE_ASSET__Ba3y7O6G__"